import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ResetService {
    constructor(private apiService: ApiService) { }

    checkResetCode(id, verificationcode) {
        return this.apiService.get('/verifyresetcode/'+ id + '/' + verificationcode).map(data => data);
    }

    ChangePassword(passwordValues) {
        return this.apiService.post('/resetpassword', passwordValues).map(data => data);
    }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/reset-management/reset-management.ts